module.exports = __webpack_public_path__ + "img/logo-cer.4349ed8d.svg";